import { useEffect, useState } from 'react'

// Wave 36 — toast paired with `useUndoableAction`. Renders nothing when
// `pending` is false; otherwise shows a fixed-position bar with the
// message + Undo button. A countdown bar drains over the configured
// delay so the operator sees how much time they have left.
//
// Wave 47w polish — moved to studio CSS classes so the toast picks up
// the platform's glass + elevation tokens. The slide-in entrance is
// what makes it feel like a Linear-tier confirmation, not a popup.

export function UndoToast({
  pending,
  message,
  onUndo,
  delayMs = 8000,
  onDismiss = null,
}) {
  const [progress, setProgress] = useState(1)

  useEffect(() => {
    if (!pending) {
      setProgress(1)
      return undefined
    }
    const start = Date.now()
    const id = setInterval(() => {
      const elapsed = Date.now() - start
      const remaining = Math.max(0, 1 - elapsed / delayMs)
      setProgress(remaining)
      if (remaining <= 0) {
        clearInterval(id)
        if (onDismiss) onDismiss()
      }
    }, 80)
    return () => clearInterval(id)
  }, [pending, delayMs, onDismiss])

  if (!pending) return null

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="undo-toast"
      className="studio-undo-toast"
    >
      <span className="studio-undo-toast-message">{message}</span>
      <button
        type="button"
        onClick={onUndo}
        data-testid="undo-toast-button"
        className="studio-undo-toast-action"
      >
        Undo
      </button>
      <div
        aria-hidden="true"
        className="studio-undo-toast-progress"
        style={{ width: `${progress * 100}%` }}
      />
    </div>
  )
}
